import { Navigate } from "react-router-dom";
import './registry.css'
import fig from '../images/fig-hammer.png'
import williamssonoma from '../images/WS_horizontal.svg'
import etsy from '../images/etsy.png'

function Registry() {
    if (window.sessionStorage.getItem("loggedIn") !== "TRUE") {
        return <Navigate to="/" />
    }
    return (
        <div className="container-text">
            <div className="body-text">
                <p>We are registered at Williams Sonoma and Etsy!</p>
                <p>Check out our registries below!</p>

                <div className="row">
                    <a className="logo" href="https://www.williams-sonoma.com/registry/rljpkcsd65/registry-list.html"><img style={{ width: "30vw" }} src={williamssonoma} alt="Williams Sonoma logo"/></a>
                    <a className="logo" href="https://www.etsy.com/registry/MTcwODUwMjMyfDgxMjk5ODU4"><img style={{ width: "20vw" }} src={etsy} alt="Etsy logo"/></a>
                </div>
                <div style={{height:"8vh"}}></div>
                <p>Cash or non-registry gifts are also welcome. The greatest gift of all is your presence at our wedding :)</p>
            </div>
            <img src={fig} height='600px' alt="Silly little cat with a hammer" />
        </div>
    )
}

export default Registry;